import { useTranslation } from "react-i18next";

export default function ComparisonSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-8">
          {t("comparison.title")}
        </h2>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300">
                <th className="py-3 px-4 text-left text-sm font-semibold text-foreground-900">{t("comparison.col1")}</th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-foreground-900">{t("comparison.col2")}</th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-foreground-900">{t("comparison.col3")}</th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-foreground-900">{t("comparison.col4")}</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200">
                <td className="py-4 px-4 text-sm text-foreground-800">{t("comparison.manual_method")}</td>
                <td className="py-4 px-4 text-sm text-foreground-600">{t("comparison.manual_time")}</td>
                <td className="py-4 px-4 text-sm">
                  <span className="inline-flex items-center gap-1 text-foreground-600 font-medium">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-error-warning-line text-sm"></i>
                    </div>
                    {t("comparison.manual_risk")}
                  </span>
                </td>
                <td className="py-4 px-4 text-sm text-foreground-600">{t("comparison.manual_result")}</td>
              </tr>
              <tr>
                <td className="py-4 px-4 text-sm font-semibold text-foreground-900">{t("comparison.spreadsheet_method")}</td>
                <td className="py-4 px-4 text-sm">
                  <span className="inline-flex items-center gap-1 text-accent-700 font-medium">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-checkbox-circle-line text-sm"></i>
                    </div>
                    {t("comparison.spreadsheet_time")}
                  </span>
                </td>
                <td className="py-4 px-4 text-sm">
                  <span className="inline-flex items-center gap-1 text-accent-700 font-medium">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-checkbox-circle-line text-sm"></i>
                    </div>
                    {t("comparison.spreadsheet_risk")}
                  </span>
                </td>
                <td className="py-4 px-4 text-sm">
                  <span className="inline-flex items-center gap-1 text-accent-700 font-medium">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-checkbox-circle-line text-sm"></i>
                    </div>
                    {t("comparison.spreadsheet_result")}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}